import React from 'react';
import styles from './no_schools.module.css';
import Head from 'next/head';
import { Button } from '@uchi/dino-button';
import Link from 'next/link';
import Image from 'next/image';
import getConfig from 'next/config';
import { useRouter } from 'next/router';

const { publicRuntimeConfig } = getConfig();

const Index = () => {
  const router = useRouter();
  const canonicalUrl = `${publicRuntimeConfig.BASE_URL}${router.asPath}`;
  return (
    <>
      <Head>
        <title>Вы не прикреплены к школе</title>
        <link rel="canonical" href={canonicalUrl} />
      </Head>
      <div className={styles.wrapper}>
        <Link href="/">
          <a className={styles.link}>
            <Image
              src={'https://static.uchi.ru/files/school-pages/icons/arrow_left.svg'}
              width={20}
              height={20}
              alt="Назад"
              className={styles.link_image}
            />
            К рейтингу учебных заведений
          </a>
        </Link>

        <div className={styles.text_wrapper}>
          <p className={styles.title}>Вы не прикреплены к школе</p>
          <span className={styles.subtitle}>
            Чтобы прикрепиться, выберите учебное заведение в&nbsp;настройках аккаунта
            на&nbsp;Учи.ру
          </span>
        </div>
        <div className={styles.buttons}>
          <Button
            bgColor="color-secondary-base"
            as="a"
            href="https://uchi.ru/ "
            target="_blank"
            className={styles.button}
          >
            Перейти в настройки
          </Button>
        </div>
      </div>
    </>
  );
};

export default Index;
